<template>
  <div class="login">
    <div class="logo">
      <img src="@/assets/images/logo.png" alt="" />
      <p>南京东路街道智慧养老平台</p>
    </div>
    <!-- <input v-model="input" placeholder="请输入手机号" /> -->
    <div class="userInfo">
      <div class="phone">
        <img src="@/assets/images/phone-1.png" alt="" />
        <input type="text" v-model="form.phone" placeholder="请输入手机号" />
      </div>
      <div class="code">
        <img src="@/assets/images/phone-2.png" alt="" />
        <input
          type="text"
          v-model="form.code"
          placeholder="请输入验证码"
          maxLength="6"
          @input="change"
        />
        <span v-show="!isStart" @click="getCode">获取验证码</span>
        <span v-show="isStart"
          ><van-count-down
            ref="countDown"
            :time="60000"
            :auto-start="false"
            format="ss秒后再获取"
            @finish="finish"
        /></span>
      </div>
      <button v-if="isLogin">登录</button>
      <button v-else class="active-button" @click="login">登录</button>
      <p>未注册手机验证后自动登录</p>
    </div>
    <div class="bottom">
      <van-checkbox v-model="checked"></van-checkbox>
      <div>
        同意<a @click="goText('xy')">《用户协议》</a>和<a href="/privacy"
          >《隐私政策》</a
        >
      </div>
    </div>

    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '150px' }"
    >
      <p>
        已阅读并同意<a @click="goText('xy')">《用户协议》</a>和<a
          @click="goText('ys')"
          >《隐私政策》</a
        >
      </p>
      <div>
        <span @click="cancel">取消</span>
        <span @click="consent">同意</span>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { getSmsLogin, login } from "@/api/user.js";
import { Toast } from "vant";
export default {
  name: "Login",
  data() {
    return {
      form: {
        phone: "",
        code: ""
      },
      checked: "",
      show: false, //协议弹窗
      isStart: false, //是否点击获取验证码
      isLogin: true, //是否输入信息
      phoneVerify: /^(0|86|17951)?(1[3456789]\d{9})$/
    };
  },
  methods: {
    ...mapMutations("user", ["setOpenId"]),

    // 登录
    login() {
      if (!this.checked) {
        // 弹出勾选协议
        this.show = true;
        return false;
      }
      login(this.form)
        .then(res => {
          if (res.code === 0) {
            window.localStorage.setItem("openId", res.data);
            this.setOpenId(res.data);
            // this.$router.push("/user");
            this.$router.go(-1);
          } else {
            // 登录失败
            Toast(res.msg);
          }
        })
        .catch(() => {
          Toast("登录失败！");
        });
    },
    getCode() {
      if (!this.form.phone) {
        Toast("请输入手机号！");
        return false;
      } else if (!this.phoneVerify.test(this.form.phone)) {
        Toast("手机号格式有误，请重新输入！");
        return false;
      }
      this.isStart = true;
      this.$refs.countDown.start();
      getSmsLogin({ phone: this.form.phone })
        .then(res => {
          if (res.code === 0) {
            Toast("发送验证码成功！");
          } else {
            Toast("发送验证码失败！");
          }
        })
        .catch(() => {
          Toast("发送验证码失败！");
        });
    },
    // 验证码倒计时结束后重置
    finish() {
      this.isStart = false;
      this.$refs.countDown.reset();
    },
    change() {
      // console.log(this.form.code.length)
      if (this.isStart && this.form.code.length === 6) {
        // console.log(1111);
        this.isLogin = false;
      } else {
        this.isLogin = true;
      }
    },
    consent() {
      this.checked = true;
      this.show = false;
      setTimeout(() => {
        this.login();
      }, 1000);
    },
    cancel() {
      this.show = false;
    },
    goText(val) {
      if (val == "xy") {
        this.$router.push("/agreement");
      } else if (val == "ys") {
        this.$router.push("/privacy");
      }
    }
  },
  computed: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.login {
  padding-top: 80px;
  .logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    // margin-top: 80px;
    // justify-content: center;
    p {
      font-family: "MiSans";
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 32px;
      color: #000000;
      margin-top: 20px;
    }
  }
  .userInfo {
    margin-top: 37px;
    padding: 0 20px;
    div {
      width: 100%;
      height: 50px;
      background: #f6f6f6;
      border-radius: 22px;
      overflow: hidden;
      display: flex;
      align-items: center;
      img {
        margin: 0 12px 0 17px;
      }
      input {
        width: 100%;
        height: 100%;
        font-weight: 400;
        font-size: 20px;
        line-height: 50px;
        background: #f6f6f6;
        color: #222222;
      }
    }
    .code {
      position: relative;
      margin-top: 21px;
      span {
        width: 120px;
        height: 100%;
        position: absolute;
        font-weight: 400;
        font-size: 16px;
        line-height: 50px;
        color: #e6b400;
        text-align: center;
        top: 0;
        right: 0;
      }
    }
    p {
      font-family: "MiSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      /* identical to box height, or 133% */
      margin-top: 16px;
      color: #666666;
      text-align: center;
    }
    button {
      margin-top: 30px;
      width: 100%;
      height: 48px;
      background: #cccccc;
      border-radius: 24px;
      border: none;
      font-weight: 400;
      font-size: 20px;
      // line-height: 48px;
      color: #222222;
      // mix-blend-mode: normal;
      opacity: 0.32;
      &.active-button {
        background: #ffd63c;
        opacity: 1;
      }
    }
  }
  .bottom {
    width: 100%;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #222222;
    position: absolute;
    bottom: 30px;
    // padding: 0 68px;
    z-index: 999;
    display: flex;
    justify-content: center;
    div {
      margin-left: 5px;
    }
    a {
      color: #e6b400;
    }
  }
  .van-popup {
    p {
      padding: 38px 0 42px;
      text-align: center;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 21px;

      color: #222222;
      a {
        color: #e6b400;
      }
    }
    div {
      border-top: 1px solid #e5e5e5;
      height: 45px;
      line-height: 30px;
      span {
        display: inline-block;
        width: 49%;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;

        color: #333333;
        text-align: center;
        &:nth-child(2) {
          color: #e6b400;
          border-left: 1px solid #e5e5e5;
        }
      }
    }
  }
}
</style>
